import { create } from 'zustand';

interface LoginAndRegisterState {
  isLoginOpen: boolean;
  isRegisterOpen: boolean;
  openLogin: () => void;
  openRegister: () => void;
  close: () => void;
}

export const useLoginAndRegisterStore = create<LoginAndRegisterState>((set) => ({
  isLoginOpen: false,
  isRegisterOpen: false,
  openLogin: () => set({ isLoginOpen: true, isRegisterOpen: false }),
  openRegister: () => set({ isLoginOpen: false, isRegisterOpen: true }),
  close: () => set({ isLoginOpen: false, isRegisterOpen: false }),
}));
